const tcgAssetBase = () => import.meta.env.VITE_S3_ASSET_URL.replace(/\/$/, "");

/** e.g. …/assets/tcg/Ultimate/Card-3.webp */
export const tcgCardImageUrl = (rarity: string, filename: string) =>
  `${tcgAssetBase()}/tcg/${encodeURIComponent(rarity)}/${encodeURIComponent(filename)}`;

export const TCG_PAGE_SLUG = import.meta.env.VITE_TCG_PAGE_SLUG ?? "";
